'use strict';

import mainConfig from '../config/config.json';
import reportsConfig from '../config/reports.json';
import notificationsConfig from '../config/notifications.json';

export default angular
  .module('maestro.services.config', [])
  .provider('config', config)
  .name;

function config() {
  let config = {};

  const configs = [
    mainConfig,
    reportsConfig,
    notificationsConfig
  ];

  const service = {
    getLocationTypeById: getLocationTypeById,
    getLocationTypes: getLocationTypes,
    getLocationSubTypes: getLocationSubTypes,
    getConfigByKey: getConfigByKey,
    getConfigItemByKeyAndId: getConfigItemByKeyAndId
  };

  init();

  angular.extend(this, service);

  this.$get = function() {
    return angular.extend(this, service);
  };

  function init() {
    angular.merge(config, ...configs);
  }

  function getLocationTypeById(id) {
    if (!id) {
      return void 0;
    }
    return this.getConfigItemByKeyAndId('locationTypes', id);
  }

  function getLocationTypes() {
    return angular.copy(config.locationTypes);
  }

  function getLocationSubTypes() {
    return angular.copy(config.locationSubTypes);
  }

  /**
   * Get configuration entry by path
   * @param {...<string|string[]>} args path that can be defined as string, dot-separated string or Array of strings
   * @return {*}
   */
  function getConfigByKey(...args) {
    let keyPath = args
      .reduce((previousValue, currentValue) => {
        if (!currentValue) {
          return previousValue;
        } else if (typeof currentValue === 'string') {
          return previousValue.concat(currentValue.split('.'));
        } else if (Array.isArray(currentValue)) {
          return previousValue.concat(currentValue);
        } else {
          previousValue.push(currentValue.toString());
          return previousValue;
        }
      }, []);

    let result = keyPath.reduce((subCfg, fieldName) => {
      if (subCfg == null) {
        return void 0;
      }
      return subCfg[fieldName];
    }, config);

    return angular.copy(result);
  }

  /**
   * Get element in some array in configuration file by "id" field.
   * @param {string|string[]} key string, dot-separated string or Array of strings leading to some Array<{id: any}> element in config file.
   * @param {*} id id that you looking for.
   * @return {*}
   */
  function getConfigItemByKeyAndId(key, id) {
    let element = getConfigByKey(key)
      .find(el => el.id == id);
    return angular.copy(element);
  }
}
